/**
 * Controllers for the mobile menu and the mobile scoreboard
 */

( function ( document, $ ) {
	const mobileToggle = $( '#js-mobile-menu-button' );
	const mobileMenu   = $( '#js-site-mobile-navigation' );
	mobileToggle.on( 'click', mobileMenuToggle );
	mobileToggle.on( 'keydown', function ( event ) {
		// monitor key actioins
		if ( 'Enter' === event.key ) {
			event.preventDefault();
			mobileMenuToggle.call( this ); // Call the toggle function
		}
	} );

	$( '.mobile-sub-menu-toggle > a' ).on( 'click', mobileSubmenuToggle );

	mobileMenu.on( 'keydown', handleMobileMenuFocusBehavior );

	const scoreboardToggle = $( '#mobile-scoreboard-toggle' );
	const scoreboard = $( '#site-header__scoreboard' );
	scoreboardToggle.on( 'click', mobileScoreboardToggle );

	/**
	 * Action to happen when the mobile menu button is clicked
	 */
	function mobileMenuToggle() {
		const isMenuClosing = 'true' === mobileToggle.attr( 'aria-expanded' );

		_toggleAria( mobileToggle, 'aria-expanded' );

		/*
		We can't get heights for elements that are display: none, which means that we can't
		adjust the height of the menu until it's open, which is too late. So we set the
		height using the values we do know even when the menu is closed: (viewport height) - (height of utility bar).
		The CSS flex rules that forces the last section inside ul#v2-main-mobile (.menu-section-menu)
    to take all remaining height does the rest.
    */
		const utilityBarHeight = $( '.mobile-utility-navigation' ).outerHeight( true );
		const menuContainerHeight = $( window ).height() - utilityBarHeight;
		mobileMenu.height( menuContainerHeight );

		// Close the bubble guy if it's active
		mobileCloseLogin();

		mobileToggle.toggleClass( 'activated' );
		mobileToggle.toggleClass( 'site-mobile-navigation--animatable' );
		mobileMenu.slideToggle( 'fast' );

		// Prevents page scrolling when the menu is open
		$( document.body ).toggleClass( 'menu-active' );

		// Change focus when open menu
		setTimeout( () => {
			if( !isMenuClosing && 'block' === mobileMenu.css( 'display' ) ) {
				mobileMenu.focus();
			}
		}, 100 );
		// Change focus when close menu
		if ( 'none' !== scoreboard.css( 'display' ) ) {
			mobileScoreboardCloseMenu();
		}
	}


	/**
	 * Toggle the scoreboard when the toggle item is clicked
	 */
	function mobileScoreboardToggle() {
		const isMenuClosing = 'true' === scoreboardToggle.attr( 'aria-expanded' );

		_toggleAria( scoreboardToggle, 'aria-expanded' );
		scoreboardToggle.toggleClass( 'activated' );
		scoreboard.slideToggle( 'fast' );

		// Change focus when open menu
		setTimeout( () => {
			if( !isMenuClosing && 'block' === scoreboard.css( 'display' ) ) {
				scoreboard.focus();
			}
		}, 100 );

		if ( 'none' !== scoreboard.css( 'display' ) ) {
			mobileCloseMenu();
		}
	}

	/*
	When the mobile view is active and the user has toggled the scoreboard open and then closed,
	the scoreboard will be hidden. When the user then resizes the screen to larger than mobile,
	the scoreboard will remain hidden unless this code runs to reset it.

	When the mobile view is active and the user has toggled the menu open and then resizes the
	screen to larger than mobile, the menu will be hidden by CSS but will still be in the toggled-open
	state. This will reset the toggle and the menu.
	 */
	function mobileItemsReset() {
		const currentWidth = window.innerWidth;

		if ( 768 > previousWidth && 768 <= currentWidth ) {
			// If we are getting bigger, then reset the menu toggle and force the menu closed
			mobileCloseMenu();

			// Same with login
			mobileCloseLogin();

			// If we are getting bigger, then reset the scoreboard toggle and force the scoreboard visible
			// but only if the scoreboard toggle has been used, which we determine based on
			// whether there is a style attached to the scoreboard directly
			const displayValue = scoreboard.css( 'inline-block' );
			if ( '' !== displayValue ) {
				//console.log( 'Force-opening the scoreboard' );
				scoreboard.slideDown( 'fast' );
				scoreboardToggle.addClass( 'activated' );
			}
		}
		previousWidth = currentWidth;
	}


	/**
	 * Close the mobile menu and reset toggle classes
	 */
	function mobileCloseMenu() {
		//console.log( 'Force-closing the menu' );
		mobileMenu.slideUp( 'fast' );
		mobileToggle.removeClass( 'activated' );
		mobileToggle.removeClass( 'site-mobile-navigation--animatable' );
		_toggleAria( mobileToggle, 'aria-pressed', false );
		_toggleAria( mobileToggle, 'aria-expanded', false );
		$( document.body ).removeClass( 'menu-active' );
	}

	/**
	 * Close the mobile scoreboard menu and reset toggle classes
	 */
	function mobileScoreboardCloseMenu() {
		//console.log( 'Force-closing the scoreboard' );
		scoreboard.slideUp( 'fast' );
		scoreboardToggle.removeClass( 'activated' );
		_toggleAria( scoreboardToggle, 'aria-pressed', false );
		_toggleAria( scoreboardToggle, 'aria-expanded', false );
	}


	/**
	 * Close the login menu and reset toggle classes
	 */
	function mobileCloseLogin() {
		//console.log( 'Force-closing bubble boy' );
		$( '.site-header-user-login' )
			.removeClass( 'dropdown-is-active' )
			.find( '#user-login' )
			.attr( 'aria-hidden', 'true' );
		document.body.classList.remove( 'dropdown-active' );
	}


	let previousWidth = window.innerWidth;
	window.addEventListener( 'resize', mobileItemsReset );


	/**
	 * Handles the submenu behaviour inside .menu-section-menu
	 *
	 * @param event <li> item clicked
	 */
	function mobileSubmenuToggle( event ) {
		// Prevent default anchor behavior
		event.preventDefault();

		const $subMenu = $( this ).parent().children( 'ul.sub-menu' );

		// Hide all direct descendant sub-menus that are not the one clicked
		$( this ).parent().closest( '.mobile-sub-menu-toggle' ).siblings().children( 'ul.sub-menu' ).fadeOut();

		// Remove the active class from all .mobile-sub-menu-toggle then add to activate one
		$( '.mobile-sub-menu-toggle' ).each( function() {
			$( this ).removeClass( 'activated' );
		} );
		$( this ).parent().addClass( 'activated' );

		$subMenu.fadeIn();
	}

	/**
	 * Toggle aria attributes.
	 *
	 * @param  {button} $this     passed through
	 * @param  {aria-xx} attribute aria attribute to toggle
	 * @return {bool}           from _ariaReturn
	 */
	function _toggleAria( $this, attribute, value = null ) {
		$this.attr(
			attribute, function( index, currentValue ) {
				if ( null !== value ) {
					return value ? 'true' : 'false';
				}
				return 'false' === currentValue;
			}
		);
	}



	// Set the first item as the menu item section to show when opening the menu for the first time.
	const firstMobileSubMenuToggle = $( 'ul#v2-main-mobile .menu-section-menu' ).find( '.mobile-sub-menu-toggle' ).first().children( 'a' );
	firstMobileSubMenuToggle.trigger( 'click' );

	// eslint-disable-next-line eqeqeq
	const isNESN = 1 == window.arsenalVars.isNESN;
	const focusableElements = mobileMenu.find( 'a' );
	const streamingElement = focusableElements.filter( function() {
		return 'Streaming' === $( this ).text();
	} ).first();
	const nflElement = focusableElements.filter( function() {
		return 'NFL' === $( this ).text();
	} ).first();
	/**
	 * Monitor key actions of mobile submenu, when exit submenu go back to togglebutton
	 * @param {*} event
	 */
	let lastFocusable = isNESN ? streamingElement : nflElement;
	function handleMobileMenuFocusBehavior( event ) {
		// Determine the active element
		const activeElement = $( mobileMenu[ 0 ].ownerDocument.activeElement );
		setTimeout( () => {
			if ( 'keydown' === event.type ) {
				if ( 'Tab' === event.key ) {
					// go back and leaving the component
					if ( event.shiftKey && ( activeElement.is( mobileMenu ) || activeElement.is( mobileMenu.eq( 2 ) ) ) ) {
						mobileToggle.focus();
						mobileCloseMenu();
					} else if ( !event.shiftKey && activeElement.is( lastFocusable ) ) {
						// go next and leaving the component
						mobileCloseMenu();
					}
				} else if ( 'Enter' === event.key ) {
					if ( ( isNESN && 'Streaming' === event.target.innerText ) || ( !isNESN && 'NFL' === event.target.innerText ) ) {
						lastFocusable = focusableElements.last();
					} else {
						lastFocusable = isNESN ? streamingElement : nflElement;
					}
				}
			}
		}, 0 );
	}

} )( document, jQuery );
